<script setup>
import { useRouter } from 'vue-router';
import {computed, onMounted, ref} from "vue";
import axios from "axios";
import {useStore} from "vuex";
import { Drawer as TDrawer } from 'tdesign-vue-next';

const router = useRouter();
const store = useStore();
const productId = computed(() => parseInt(store.getters.getProductId));
const guid = computed(() => store.getters.getGuid);
const qq = computed(() => store.getters.getQq);
const softVersion = computed(() => store.getters.getSoftVersion);
const hasNew = ref(false);
const feedbackUrl = ref('');

const params = new URLSearchParams(window.location.search);

function versionCompare(thisVersion, targetVersion) {
  // 版本号比较函数，如果thisVersion大于等于targetVersion，返回true，否则返回false
  // 参数校验：如果版本号为空或无效，返回false
  if (!thisVersion || !targetVersion || typeof thisVersion !== 'string' || typeof targetVersion !== 'string') {
    return false;
  }
  const thisVersionArr = thisVersion.split('.');
  const targetVersionArr = targetVersion.split('.');
  if(thisVersionArr.length !== targetVersionArr.length) {
    return false;
  }
  try {
    for (let i = 0; i < thisVersionArr.length; i++) {
      let thisVersionNum = parseInt(thisVersionArr[i]);
      let targetVersionNum = parseInt(targetVersionArr[i]);
      if(isNaN(thisVersionNum)) {
        return false;
      }
      if (thisVersionNum > targetVersionNum) {
        return true;
      } else if (thisVersionNum < targetVersionNum) {
        return false;
      } else {
        if (i === thisVersionArr.length - 1) {
          return true;
        }
      }
    }
  } catch (e) {
    return false;
  }
  return false;
}

const isHuanJi = computed(() => {
  // 判断是否是换机助手App，且换机助手App版本支持跳转，针对换机助手，展示不一样的底部按钮
  // 换机助手productId：安卓版 7，iOS版 8，鸿蒙版 66
  // 换机助手支持跳转的版本：安卓1.5.46及以上，iOS 1.0.59及以上，鸿蒙1.1.1及以上
  const appVersionNumber = params.get('VersionNumber');
  console.log('app 版本号：', appVersionNumber, 'productId:', productId.value);
  let result = false;
  switch (productId.value) {
    case 7:
      result = versionCompare(appVersionNumber, '1.5.46');
      break;
    case 8:
      result = versionCompare(appVersionNumber, '1.0.59');
      break;
    case 66:
      result = versionCompare(appVersionNumber, '1.1.1');
      break;
  }
  return result;
});
const drawerVisible = ref(false);

onMounted(() => {
  const queryData = {
    productId: productId.value,
    guid: guid.value,
  };
  if (qq.value !== '') {
    queryData.qq = qq.value;
  }

  axios.get('/feedback',{ params: queryData }).then(res => {
    if (res.data && res.data.content) {
      res.data.content.forEach(item => {
        if(item.readStatus > 0){
          hasNew.value = true;
        }
      });
      console.log('my feedbacks', res.data);
    } else {
      console.error('Invalid response data:', res.data);
    }
  }).catch(err => {
    console.log(err);
  });

  let temp = window.location.href.split('#!/');
  temp[1] = 'feedback';
  feedbackUrl.value = temp.join('#!/');
});


const goToFeedback = () => {
  console.log('测试-new');
  if (isHuanJi.value) {
    // 对于换机App，点击后弹出Drawer
    drawerVisible.value = !drawerVisible.value;
  } else {
    router.push({
      path: '/feedback',
    });
  }
};

function goToMyList() {
  router.push({
    path: '/myList',
  });
}

// 跳转到后台留言页面
function goToBackgroundMessage() {
  router.push({
    path: '/feedback',
  });
}

// 跳转到人工客服
function goToCustomerService() {
  window.location.href = 'https://sdi.3g.qq.com/v/2025111410063611587';
}
</script>

<template>
  <div class="entrance-box">
    <!-- @click="goToMyList()" -->
    <div class="my-box" @click="goToMyList()">
      <div class="message-indicator" v-if="hasNew"></div>
      <img src="../assets/my.png"  alt="."/>
      <p>反馈进度</p>
    </div>
    <div class="feedback" @click="goToFeedback()">我要反馈</div>
  </div>
  <t-drawer v-model:visible="drawerVisible" :footer="false" :header="false" placement="bottom" size="18vh">
    <div>
      <div class="content" @click="goToBackgroundMessage()">
        <svg xmlns="http://www.w3.org/2000/svg" width="9vw" height="9vw" viewBox="0 0 68 68" fill="none" style="margin-left: 2vw;margin-right: 3vw;">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M49.0754 24.275C49.0754 21.7899 47.0605 19.7752 44.5754 19.775H23.425C20.9397 19.775 18.925 21.7897 18.925 24.275V39.0065C18.9252 41.4916 20.9399 43.5065 23.425 43.5065H44.6818L44.8244 43.5133C45.1555 43.5449 45.4684 43.6854 45.7121 43.9156L49.0754 47.0934V24.275ZM52.0754 50.5748C52.0754 51.1738 51.7183 51.7157 51.1682 51.9528C50.6184 52.1895 49.9803 52.0766 49.5451 51.6656L44.0852 46.5065H23.425C19.283 46.5065 15.9252 43.1484 15.925 39.0065V24.275C15.925 20.1329 19.2829 16.775 23.425 16.775H44.5754C48.7174 16.7752 52.0754 20.133 52.0754 24.275V50.5748ZM41.2248 26.1252C42.0532 26.1252 42.7248 26.7968 42.7248 27.6252C42.7247 28.4536 42.0532 29.1252 41.2248 29.1252H25.925C25.0966 29.1252 24.4251 28.4536 24.425 27.6252C24.425 26.7968 25.0966 26.1252 25.925 26.1252H41.2248ZM36.7746 35.2752C36.7746 34.4468 36.103 33.7752 35.2746 33.7752H25.925C25.0966 33.7752 24.425 34.4468 24.425 35.2752C24.4251 36.1036 25.0966 36.7752 25.925 36.7752H35.2746C36.103 36.7752 36.7745 36.1036 36.7746 35.2752Z" fill="#444444"/>
        </svg>
        后台留言
        <svg xmlns="http://www.w3.org/2000/svg" width="9vw" height="9vw" viewBox="0 0 60 60" fill="none" style="position:absolute;right: 0;">
          <path d="M24.4054 17L36.3966 28.9912C37.1776 29.7722 37.1776 31.0386 36.3966 31.8196L24.4054 43.8108" stroke="#BBBBBB" stroke-width="3"/>
        </svg>
      </div>
      <div class="divider"></div>
      <div class="content" @click="goToCustomerService()">
        <svg xmlns="http://www.w3.org/2000/svg" width="9vw" height="9vw" viewBox="0 0 68 68" fill="none" style="margin-left: 2vw;margin-right: 3vw;">
          <path d="M47.5721 28.1058C47.5721 20.564 41.4582 14.4501 33.9164 14.4501C26.3745 14.4501 20.2607 20.564 20.2607 28.1058" stroke="#444444" stroke-width="3"/>
          <path d="M22.5248 27.85H23.8002C23.9106 27.8501 24.0004 27.9398 24.0004 28.0502V42.5004C24.0002 42.6106 23.9104 42.6995 23.8002 42.6996H22.5248C18.4242 42.6995 15.1 39.3754 15.1 35.2748C15.1001 31.1742 18.4243 27.8501 22.5248 27.85Z" stroke="#444444" stroke-width="3"/>
          <path d="M45.4752 27.85H44.1998C44.0894 27.8501 43.9996 27.9398 43.9996 28.0502V42.5004C43.9998 42.6106 44.0896 42.6995 44.1998 42.6996H45.4752C49.5758 42.6995 52.9 39.3754 52.9 35.2748C52.8999 31.1742 49.5757 27.8501 45.4752 27.85Z" stroke="#444444" stroke-width="3"/>
          <path d="M46.8894 43.1272C46.8894 48.0294 42.9153 52.0034 38.0131 52.0034" stroke="#444444" stroke-width="3"/>
          <circle cx="36.6475" cy="52.0033" r="2.04836" fill="#444444"/>
        </svg>
        人工客服
        <svg xmlns="http://www.w3.org/2000/svg" width="9vw" height="9vw" viewBox="0 0 60 60" fill="none" style="position:absolute; right: 0px;">
          <path d="M24.4054 17L36.3966 28.9912C37.1776 29.7722 37.1776 31.0386 36.3966 31.8196L24.4054 43.8108" stroke="#BBBBBB" stroke-width="3"/>
        </svg>
      </div>
    </div>
  </t-drawer>
</template>

<style lang="scss" scoped>
@import '~/entries/index/index.scss';
.entrance-box {
  display: flex;
  align-items: center;
  margin: 0;
  background: #fff;
  width: 100%;
  height: 141 * $px;
  position: fixed; /* 设置entrance-box为绝对定位 */
  bottom: 0; /* 将entrance-box固定在底部 */

  .my-box {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 93 * $px;
    align-items: center; /* 垂直居中对齐 */
    margin-left: 36 * $px;
    .message-indicator {
      position: absolute;
      top: 10 * $px;
      right: 10 * $px;
      width: 8 * $px;
      height: 8 * $px;
      background-color: red;
      border-radius: 50%;
    }
    img {
      width: 60 * $px;
      height: 60 * $px;
    }
    p {
      margin: 0;
      font-size: 24 * $px;
      line-height: 33.6 * $px;
    }
  }
  .feedback {
    background: rgba(231, 235, 255, 1);
    color: rgba(75, 106, 255, 1);
    font-size: 35 * $px;
    line-height: 93 * $px;
    text-align: center;
    border: none;
    border-radius: 60 * $px;
    width: 542 * $px;
    height: 93 * $px;
    margin-left: 36 * $px;
  }
}

.content {
  width: 100%;
  height: 14vw;
  position: relative;
  font-size: 4vw;
  display: flex;
  align-items: center;
  cursor: pointer;
  
  &:active {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
.divider {
  width: 100%;
  height: 1px;
  background-color: #EEEEEE;
}
</style>
